import { UPDATE_ACTIVE_FOLDER,UPDATE_OPEN_OR_CLOSE_FOLDER,
    ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU,ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU_CHILD,
    ADMIN_ACTVE_MENU,USER_GET_INTERFACE
} from "./Contant";


export const updateActiveFolder=payload=>({
    type:UPDATE_ACTIVE_FOLDER,
    payload
})

export const updateOpenOrCloseFolder=payload=>({
    type:UPDATE_OPEN_OR_CLOSE_FOLDER,
    payload
})

export const updateAdminOpenOrCloseVerticalMenu=payload=>({
    
    type:ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU,
    payload
})

export const updateAdminOpenOrCloseVerticalMenuChild=payload=>({
    type:ADMIN_OPEN_OR_CLOSE_VERTICAL_MENU_CHILD,
    payload
})

export const updateAdminActiveMenu=payload=>(
    {
        type:ADMIN_ACTVE_MENU,
        payload
    }
)

export const getUserInterface=payload=>(
    {
        type:USER_GET_INTERFACE,
        payload
    }
)

